const collator = new Intl.Collator('sv');

export default function compareStrings(first: string, second: string): number {
  return collator.compare(first, second);
}
